import React from 'react'
import PropTypes from 'prop-types'
import MuiCard from '@mui/material/Card'
import Typography from '@mui/material/Typography'

export const Card = ({
  title,
  children,
  onClick,
  className,
  sx,
  elevation,
  ...otherProps
}) => (
  <MuiCard
    elevation={elevation}
    onClick={onClick}
    className={className}
    sx={[
      {
        border: '1px solid var(--border-subtle)',
        borderRadius: 'var(--radius-lg)',
        padding: 'var(--space-4)',
        boxShadow: 'var(--shadow-sm)',
        ...(onClick && {
          cursor: 'pointer',
          '&:hover': {
            borderColor: 'var(--color-brand)',
            boxShadow: 'var(--shadow-md)',
          },
        }),
      },
      sx,
    ]}
    {...otherProps}
  >
    {title && (
      <Typography
        component="h3"
        sx={{
          fontFamily: 'var(--font-primary)',
          fontSize: '16px',
          fontWeight: 600,
          margin: 0,
          mb: 'var(--space-3)',
        }}
      >
        {title}
      </Typography>
    )}
    {children}
  </MuiCard>
)

Card.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  className: PropTypes.string,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  elevation: PropTypes.number,
}

Card.defaultProps = {
  sx: {},
  elevation: 0,
}
